<h2 mat-dialog-title>
  {{ "brand.campaign.summary.detailsPreview.title" | translate }}
  <span class="close-icon" [mat-dialog-close]="">
    <mat-icon>close</mat-icon>
  </span>
</h2>
<mat-dialog-content>
  <div class="left-content">
    <div class="campaign-body">
      <h1>{{ "brand.campaign.summary.detailsPreview.info" | translate }}</h1>
      <div [innerHTML]="campaignDescription" class="campaign-description"></div>
    </div>
    <div class="carousel" *ngIf="campaignDetails?.sliders?.length">
      <div class="carousel-img-wrapper">
        <div
          class="carousel-img static"
          [ngStyle]="{ 'background-image': 'url(' + currentImage.file + ')' }"
          (click)="showNext()"
        ></div>
        <div
          class="carousel-img slide"
          [ngClass]="{ fadeIn: isFading, hide: !isFading }"
          [style.background-image]="'url(' + nextImage.file + ')'"
          [style.--slide-transition-duration.ms]="SLIDE_TRANSITION_MS"
        ></div>
      </div>
      <ul class="carousel-controls">
        <li
          class="carousel-control"
          *ngFor="let image of campaignDetails.sliders; let idx = index"
        >
          <button
            class="carousel-item-toggle"
            (click)="showImage(idx)"
            [class.is-active]="idx === currentImageIdx"
          ></button>
        </li>
      </ul>
    </div>
    <div *ngIf="campaignDetails?.assets.length" class="assets" #assets>
      <h3>{{ "brand.campaign.summary.detailsPreview.assets" | translate }}</h3>
      <ul class="asset-list">
        <li class="asset-item" *ngFor="let asset of campaignDetails.assets">
          <a
            class="asset-item-button"
            type="button"
            href="{{ asset.file }}"
            target="_blank"
          >
            <span
              class="asset-item-img"
              style="background-image: url(ic_asset_file.svg)"
            >
            </span>
            <span class="asset-item-details">
              <span class="asset-item-name">{{ asset.name }}</span>
              <span class="asset-item-size">{{ asset.size | fileSize }}</span>
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <section class="campaign-details">
    <div class="header">
      <p>
        {{ "brand.campaign.summary.detailsPreview.detailsTitle" | translate }}
      </p>
    </div>
    <div class="info">
      <div class="group-data">
        <p class="title">
          {{ "brand.campaign.summary.detailsPreview.logo" | translate }}
        </p>
        <img class="logo" src="/assets/images/sample-partner-logo.png" />
      </div>
      <div class="group-data">
        <p class="title">
          {{ "partner.campaign.summary.defaultStoreLocation" | translate }}
        </p>
        <ng-container>
          <span class="data">Parkstraße 15,</span>
          <span class="data">99876, Gotha</span>
          <span class="data">Germany</span>
          <span class="data">-</span>
        </ng-container>
      </div>
    </div>
  </section>
</mat-dialog-content>
